import React from 'react';
const FormGroupHeader = function ({ label, children }) { if (!label && !children)
    return null; return /*#__PURE__*/ React.createElement("div", { className: "form-group__header" }, /*#__PURE__*/ React.createElement("label", { className: "form-group__label" }, label), children); };
export default FormGroupHeader;
